import { useSelector } from 'react-redux';

import { selectFeatureFlags } from '@/model/selectors';

export function useIsFreemiumAdvisor() {
  const featureFlags = useSelector(selectFeatureFlags);

  return !!featureFlags.freemiumAdvisor;
}
